export const getUserType = () => {
  return sessionStorage.getItem('sc_userType') || USER_TYPES.INSURED
}

export const setUserType = (userType = USER_TYPES.INSURED) => {
  return sessionStorage.setItem('sc_userType', userType)
}

export const getUserLocale = () => {
  return localStorage.getItem('locale') || 'fr'
}

export const isInsured = () => getUserType() === USER_TYPES.INSURED
export const isProfessional = () => getUserType() === USER_TYPES.PROFESSIONAL
export const isBillmaInsured = () => getUserType() === USER_TYPES.BILLMA_INSURED
export const isBillmaAgent = () => getUserType() === USER_TYPES.BILLMA_AGENT
export const isBillmaUser = () => getUserType() === USER_TYPES.BILLMA_USER
export const isPhotoclaim = () => getUserType() === USER_TYPES.PHOTOCLAIM
export const isRenProfessional = () =>
  getUserType() === USER_TYPES.REN_PROFESSIONAL
export const isRenInsured = () => getUserType() === USER_TYPES.REN_INSURED
export const isValidUserType = (userType) =>
  Object.values(USER_TYPES).indexOf(userType) > -1
export const isValidUserFlowState = (userFlowState) =>
  Object.values(USER_FLOW_STATES).indexOf(userFlowState) > -1

export const USER_TYPES = {
  INSURED: 'gag_insured',
  PROFESSIONAL: 'damage_professional',
  BILLMA_INSURED: 'damage_billma_insured',
  BILLMA_AGENT: 'damage_billma_agent',
  BILLMA_USER: 'billma_user',
  REN_PROFESSIONAL: 'ren_professional',
  REN_INSURED: 'ren_insured',
  REN_INSURED_SOGESSUR: 'ren_insured_soggesur',
  E2E: 'e2e',
  PHOTOCLAIM: 'photoclaim'
}

export const USER_FLOWS = {
  MANAGE_DAMAGE_GRE_A_GRE_RESPONSE: 'MANAGE_DAMAGE_GRE_A_GRE_RESPONSE',
  MANAGE_DAMAGE_CONTACT_RESPONSE: 'MANAGE_DAMAGE_CONTACT_RESPONSE',
  MANAGE_DAMAGE_APPOINTMENT_RESPONSE: 'MANAGE_DAMAGE_APPOINTMENT_RESPONSE',
  MANAGE_DAMAGE_BILLMA_RESPONSE: 'MANAGE_DAMAGE_BILLMA_RESPONSE'
}

export const USER_FLOW_STATES = {
  KO: 'KO',
  OK: 'OK',
  ERROR: 'ERROR'
}
